import React, { useState, useEffect } from 'react';
import { Document, Page, pdfjs } from 'react-pdf';
import clsx from 'clsx';
import { noop } from 'utils'
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

const options = {
    cMapUrl: `//cdn.jsdelivr.net/npm/pdfjs-dist@${pdfjs.version}/cmaps/`,
    cMapPacked: true
  };

export function PdfIndex({ url, width = 595, currentPage, onPageClick = noop, onDocumentLoad = noop, children }) {

  const [numPages, setNumPages] = useState(0);

  const onDocumentLoadSuccess = ({numPages}) => {
    setNumPages(numPages);
    onDocumentLoad({ numPages })
  };

  const handlePageClick = (page) => () => {
      console.log({page})
    onPageClick(page)
  };


  return (
    <div className="position-relative d-flex justify-content-center">
      <Document
          file={url}
          className="text-dark mb-3"
          onLoadSuccess={onDocumentLoadSuccess}
          options={options}
      >
          {Array.from(new Array(numPages), (page, index) => (
                <div key={`page_${index + 1}`} onClick={handlePageClick(index + 1)}>  {/* className="row flex-row align-items-center" */}
                  {/* <div className="col-2">
                      {
                      signaturesPerPage[index + 1]?.map(participant => (
                          <div>
                          {participant.charAt(0)} 
                          </div>
                      ))
                      }
                  </div> */}
                  {/* <div className="col-10"> */}
                    <div> {/* className="position-relative" */}
                      <Page
                          className={clsx('my-3', index + 1 === currentPage && 'border-primary-md')}
                          key={`page_${index + 1}`}
                          width={width}
                          pageNumber={index + 1}
                      />
                        {/* <div>
                            CP
                        </div> */}
                    </div>
                    <small className="d-flex justify-content-center text-dark">{index + 1}</small>
                  {/* </div> */}
                </div>
            ))}
         
      </Document>
    </div>
  )
}
